import { render, staticRenderFns } from "./VAppTextField.vue?vue&type=template&id=127e4e43"
import script from "./VAppTextField.vue?vue&type=script&lang=js"
export * from "./VAppTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports